import React, {useState, useEffect} from "react";
import {Box, Paper, Pagination, TextField, InputAdornment, Typography, useTheme} from "@mui/material";
import CustomButton from "../../../core/components/ui/CustomButton";
import CustomTypography from "../../../core/components/ui/CustomTypography";
import AddIcon from "@mui/icons-material/Add";
import useContainer from "../hooks/useContainer";
import CustomTableLoaderComponent from "../../../core/components/common/custom-table-loader.component";
import ListContainerComponent from "../components/list-container.component";
import {useNavigate, useLocation} from "react-router-dom";
import useContainerStore from "../zustand/useContainerStore";
import CustomFilterComponent from "../../../core/components/common/custom-filter.component";
import { RBACUIGuard } from "../../RBACPlugin";
import { permissions } from "../../../core/components/common/variables/static_variables";

const headers = ["Container Number", "Size & Type", "Status", "Actions"];

const ContainerPage = (props) => {
    const {isMobile, breakpoints} = props;

    const theme = useTheme();
    const navigate = useNavigate();
    const location = useLocation();

    const {isListingContainer, containerListWithPagination, getListContainerWithPagination, isFilteringContainer,
        containerTypes, getContainerTypes, containerStatusList, getContainerStatusList, filterContainer 
    } = useContainer();
    
    const {isContainerStatusUpdated} = useContainerStore();

    const [containerList, setContainerList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);

    const [filterLabel, setFilterLabel] = useState(null);
    const [filter, setFilter] = useState(null);
    const [containerNumberFilterValue, setContainerNumberFilterValue] = useState(null);
    const [typeFilterValue, setTypeFilterValue] = useState(null);
    const [statusFilterValue, setStatusFilterValue] = useState(null);

    const [containerTypeData, setContainerTypeData] = useState([]);
    const [containerStatusData, setContainerStatusData] = useState([]);

    const rowsPerPage = 10; 

    const rbacStorage = JSON.parse(localStorage.getItem("rbac-storage"));
    const storedOrgIdFromRBACForBusiness = rbacStorage?.state?.currentProfile?.orgId || null;
    const orgIdFromUrlForPortEmployee = new URLSearchParams(location.search).get("org_uid");

    const searchForOptions = [
        {value: "container_number", label: "Container Number"},
        {value: "type", label: "Type"},
        {value: "status", label: "Status"},
    ]


    useEffect(() => {
        if (filter) return;
        const organizationId = storedOrgIdFromRBACForBusiness || orgIdFromUrlForPortEmployee;

        // if (organizationId) {
            const parameters = {
                page: currentPage,
                limit: rowsPerPage,
                orgUID: organizationId
            }

            getListContainerWithPagination(parameters);

        // } else {
        //     const parameters = {
        //         page: 1,
        //         limit: rowsPerPage,
        //     }

        //     getListContainerWithPagination(parameters);
        // }

        getContainerTypes();
        getContainerStatusList();
    }, [storedOrgIdFromRBACForBusiness, orgIdFromUrlForPortEmployee, currentPage])

    useEffect(() => {
        if (containerTypes) {
            const formattedContainerTypes = containerTypes.map(type => ({value: type.toLowerCase(), label: type}));
            setContainerTypeData(formattedContainerTypes);
        }
    }, [containerTypes])

    useEffect(() => {
        if (containerStatusList) {
            const formattedContainerStatus = containerStatusList.map(type => ({value: type.toLowerCase(), label: type}));
            setContainerStatusData(formattedContainerStatus);
        }
    }, [containerStatusList])

    // useEffect(() => {
    //     const organizationId = storedOrgIdFromRBACForBusiness || orgIdFromUrlForPortEmployee;

    //     if (organizationId && (currentPage || isContainerStatusUpdated)) {
    //         const parameters = {
    //             page: currentPage,
    //             limit: rowsPerPage,
    //             orgUID: organizationId
    //         }
      
    //         getListContainerWithPagination(parameters);

    //     } else if (currentPage || isContainerStatusUpdated) {
    //         const parameters = {
    //             page: currentPage,
    //             limit: rowsPerPage,
    //         }
      
    //         getListContainerWithPagination(parameters);
    //     }
    // }, [currentPage, isContainerStatusUpdated, storedOrgIdFromRBACForBusiness, orgIdFromUrlForPortEmployee])

    useEffect(() => {
        if (containerListWithPagination) {
            setContainerList(containerListWithPagination?.content);
            setTotalPages(containerListWithPagination?.totalPages);
        } 
    }, [containerListWithPagination])

    useEffect(() => {
        if (!filter) return; // nothing to do if no filter is selected

        const organizationId = storedOrgIdFromRBACForBusiness || orgIdFromUrlForPortEmployee;
        let searchVal = null;

        if (typeFilterValue) {
            searchVal = typeFilterValue;
        } else if (statusFilterValue) {
            searchVal = statusFilterValue;
        }

        if (!searchVal) return; // skip if no value to search

        const parameters = {
            page: currentPage,
            limit: 20,
            searchFor: filter,
            searchVal,
            ...(organizationId && { orgUID: organizationId }),
        };

        filterContainer(parameters);
    }, [
        filter,
        typeFilterValue,
        statusFilterValue,
        storedOrgIdFromRBACForBusiness,
        orgIdFromUrlForPortEmployee,
        currentPage
    ]);



    const handleChangePagination = (event, page) => { 
        setCurrentPage(page); 
    }

    const handleClickOpen = () => {
        if (orgIdFromUrlForPortEmployee && !storedOrgIdFromRBACForBusiness) {
            navigate("/organization/view/containers/create?org_uid=" + orgIdFromUrlForPortEmployee);

        } else {
            navigate("/containers/create");
        }
    }

    const handleSearchForOption = (selectedOption, type) => { 
        if (selectedOption && type === "type") {
            setFilter(selectedOption.value);
            setFilterLabel(selectedOption.label);
            setStatusFilterValue(null);

        } else if (selectedOption && type === "status") {
            setFilter(selectedOption.value);
            setFilterLabel(selectedOption.label);
            setTypeFilterValue(null);

        } else {    
            handleSearchForClearFilter();
        }
    }

    const handleSearchForClearFilter = (e) => {
        setFilter(null);
        setFilterLabel(null);

        const organizationId = storedOrgIdFromRBACForBusiness || orgIdFromUrlForPortEmployee;

        if (organizationId) {
            const parameters = {
                page: 1,
                limit: rowsPerPage,
                orgUID: organizationId
            }

            getListContainerWithPagination(parameters);

        } else {
            const parameters = {
                page: 1,
                limit: rowsPerPage,
            }

            getListContainerWithPagination(parameters);
        }
    }

    const handleSearchValOption = (selectedOption, type) => {
        if (selectedOption && type === "type") {
            setTypeFilterValue(selectedOption.label);
            setStatusFilterValue(null);

        } else if (selectedOption && type === "status") {
            setStatusFilterValue(selectedOption.label); 
            setTypeFilterValue(null);

        } else {    
            handleSearchValClearFilter();
        }
    }

    const handleSearchValClearFilter = (e) => {
        setTypeFilterValue(null);
        setStatusFilterValue(null);
        setContainerNumberFilterValue("");

        const organizationId = storedOrgIdFromRBACForBusiness || orgIdFromUrlForPortEmployee;

        if (organizationId) {
            const parameters = {
                page: 1,
                limit: rowsPerPage,
                orgUID: organizationId
            }

            getListContainerWithPagination(parameters);

        } else {
            const parameters = {
                page: 1,
                limit: rowsPerPage,
            }

            getListContainerWithPagination(parameters);
        }
    }

    const handleTextfield = (e) => {
        setTypeFilterValue(null);
        setStatusFilterValue(null);
        setContainerNumberFilterValue(e.target.value);
    }

    const handleKeyPress = (e) => {
        const organizationId = storedOrgIdFromRBACForBusiness || orgIdFromUrlForPortEmployee;

        if (e.keyCode === 13 || e.key === "Enter") {
            if (organizationId && filter && containerNumberFilterValue) {
                const parameters = {
                    page: 1,
                    limit: 20,
                    searchFor: filter,
                    searchVal: containerNumberFilterValue,
                    orgUID: organizationId
                }
            
                filterContainer(parameters);

            }  else if (filter && containerNumberFilterValue) {
                const parameters = {
                    page: 1,
                    limit: 20,
                    searchFor: filter,
                    searchVal: containerNumberFilterValue
                }
            
                filterContainer(parameters);
            }  
        }
    }
    

    return (
        <>        
            <Box sx={{textAlign: "start"}}>
                <CustomTypography 
                    variant="h3"
                    text={"Containers"}
                    customStyles={{
                        marginBottom: 0, 
                    }}
                />

                <CustomTypography 
                    variant="subtitle1"
                    text={"Easily view, track, and monitor all container operations in real time"}
                    customStyles={{
                        marginBottom: 0, 
                    }}
                />
            </Box>
            
            <Paper elevation={0} sx={{border: `1px solid #e5edf6`, borderRadius: 2, padding: "24px 32px", mt: 3}}>
                <Box sx={{display: "flex", justifyContent: "right"}}>
                    <RBACUIGuard requiredPermission={permissions.containers.FILTER_LIST_CONTAINER}>
                        <CustomFilterComponent
                            width={250}
                            isSearchable={true}
                            isClearable={true}
                            filterLabel={
                                    (filterLabel === "Type") ? "Type" 
                                :  
                                    (filterLabel === "Status") ? "Status" 
                                : 
                                    (filterLabel === "Container Number") ? "Container Number" 
                                : 
                                    null
                            }
                            filterOptions={searchForOptions}
                            onChange={selectedOption => handleSearchForOption(selectedOption, filterLabel === "Type" ? "type" : "status")}
                            isSearchForFilter={true}
                            isSearchValue={false}
                        />
                    </RBACUIGuard>

                    <RBACUIGuard requiredPermission={permissions.containers.GET_CONTAINER_TYPE}>
                        {(filterLabel === null || filterLabel === "Type") && 
                            <CustomFilterComponent
                                width={300}
                                isSearchable={true}
                                isClearable={true}
                                filterLabel={filterLabel}
                                filterOptions={containerTypeData}
                                onChange={selectedOption => handleSearchValOption(selectedOption, "type")}
                                isSearchForFilter={false}
                                isSearchValue={true}
                                isDisabled={false}
                            />
                        }
                    </RBACUIGuard>

                    {(filterLabel === "Status") && 
                        <CustomFilterComponent
                            width={300}
                            isSearchable={true}
                            isClearable={true}
                            filterLabel={filterLabel}
                            filterOptions={containerStatusData}
                            onChange={selectedOption => handleSearchValOption(selectedOption, "status")}
                            isSearchForFilter={false}
                            isSearchValue={true}
                            isDisabled={false}
                        />
                    }

                    {(filterLabel === "Container Number") &&
                        <TextField
                            value={containerNumberFilterValue}
                            placeholder={"Input Container Number..."}
                            variant="outlined"
                            autoComplete="off"  
                            onChange={handleTextfield}
                            onKeyDown={handleKeyPress}
                            slotProps={{
                                input: {
                                    style: {
                                        padding: "10px",
                                        fontSize: 14,
                                        fontStyle: 'italic'
                                    },
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Typography sx={{fontSize: 14, color: theme.typography.primary, opacity: 0.85, fontStyle: "normal"}}>
                                                Container Number:
                                            </Typography>
                                        </InputAdornment>
                                    )
                                }
                            }}
                            sx={{
                                marginRight: "10px", 
                                "& .MuiInputBase-root": {
                                    height: 42, 
                                    backgroundColor: "transparent", 
                                    width: 350, 
                                    borderColor: "#dce8f5"
                                },
                                "& .MuiOutlinedInput-root": {
                                    height: 42,
                                    backgroundColor: "transparent",
                                    "& fieldset": {
                                        borderColor: "#dce8f5",
                                    },
                                    "&:hover fieldset": {
                                        borderColor: theme.palette.primary.main, 
                                    },
                                    "&.Mui-focused fieldset": {
                                        borderColor: `0 0 0 1px ${theme.palette.primary.main}`,
                                    }
                                },
                            }}  
                        /> 
                    }

                    <RBACUIGuard requiredPermission={permissions.containers.CREATE_CONTAINER}>
                        <CustomButton 
                            variant="contained" 
                            startIcon={<AddIcon fontSize="small" />}
                            label="Add Container"
                            customStyles={{fontSize: 14}}
                            onClick={handleClickOpen}
                        />
                    </RBACUIGuard>
                </Box>

                {(isListingContainer || isFilteringContainer) ?
                    <Box sx={{mt: 3}}>
                        <CustomTableLoaderComponent 
                            headers={headers} 
                            hasAction={false}
                        /> 
                    </Box>
                :   
                    <Box sx={{mt: 3, mb: (containerList?.length === 0 || containerList === undefined) ? 2 : {}}}>
                        <ListContainerComponent 
                            headers={headers} 
                            data={containerList} 
                            isMobile={isMobile}
                            breakpoints={breakpoints}
                        />
                
                        {containerList?.length > 0 &&
                            <Pagination
                                count={totalPages}
                                page={currentPage}
                                onChange={handleChangePagination}
                                sx={{
                                    margin: "auto",
                                    width: "fit-content",
                                    paddingTop: 3,
                    
                                    "& .MuiPaginationItem-root.Mui-selected": {
                                        backgroundColor: "#0b99da",      
                                        color: "#fff",               
                                    }
                                }}
                            />
                        }
                    </Box>
                }
            </Paper>
       </>
    )
}

export default ContainerPage